module.exports = __webpack_public_path__ + "media/images/webpage/hotels/743/plan4-2-8043c6644c5e2f27641201cefda11e7c.webp";